import React, { forwardRef } from "react";
import { X } from "lucide-react";
import "./Chip.css";

const tones = ["neutral", "primary", "ok", "warn", "err", "accent"];
const sizes = ["sm", "md"];

export const Chip = forwardRef(function Chip(
  {
    tone = "neutral",
    size = "md",
    soft = true,
    leftIcon = null,
    onRemove = null,
    children,
    className = "",
    ...props
  },
  ref
) {
  const classes = [
    "ui-chip",
    `ui-chip-${tones.includes(tone) ? tone : "neutral"}`,
    `ui-chip-${sizes.includes(size) ? size : "md"}`,
    soft ? "ui-chip-soft" : "ui-chip-solid",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span ref={ref} className={classes} {...props}>
      {leftIcon && <span className="ui-chip-icon">{leftIcon}</span>}
      <span className="ui-chip-label">{children}</span>
      {onRemove && (
        <button type="button" onClick={onRemove} className="ui-chip-remove" aria-label="Remove">
          <X size={12} />
        </button>
      )}
    </span>
  );
});

export function Badge({ children, tone = "neutral", className = "", ...props }) {
  return (
    <span className={`ui-badge ui-badge-${tone} ${className}`} {...props}>
      {children}
    </span>
  );
}
